import XLSXStyle from 'xlsx-style-vite';

import * as XLSX from 'xlsx'
/**
 *@Author  ahuan
 *@Description
 *@Date 2024/6/19
 **/
const serialize = data => {
    let list = [];
    Object.keys(data).forEach(ele => {
        list.push(`${ele}=${data[ele]}`);
    });
    return list.join('&');
};
function convertMilliseconds(ms) {
    const secondsInAMinute = 60;
    const minutesInAnHour = 60;
    const hoursInADay = 24;
    const daysInAMonth = 30;
    const monthsInAYear = 12;

    let remainingMilliseconds = ms;

    const seconds = Math.floor(remainingMilliseconds );

    const minutes = Math.floor(seconds / secondsInAMinute);
    const remainingSeconds = seconds % secondsInAMinute;

    const hours = Math.floor(minutes / minutesInAnHour);
    const remainingMinutes = minutes % minutesInAnHour;

    const days = Math.floor(hours / hoursInADay);
    const remainingHours = hours % hoursInADay;

    let years = 0;
    let months = 0;
    let remainingDays = days;

    if (days >= daysInAMonth) {
        months = Math.floor(days / daysInAMonth);
        remainingDays = days % daysInAMonth;

        if (months >= monthsInAYear) {
            years = Math.floor(months / monthsInAYear);
            months = months % monthsInAYear;
        }
    }

    return `${years ? years + ' 年 ' : ''}${months ? months + ' 个月 ' : ''}${remainingDays ? remainingDays + ' 天 ' : ''}${remainingHours ? remainingHours + ' 个小时' : ''}${remainingMinutes ? remainingMinutes + ' 分钟 ' : ''}${remainingSeconds ? remainingSeconds + ' 秒 ' : ''}`;
}
function exportExcel(data, titles, dirname,error = []) {
    // 新建一个工作薄
    var sheet = XLSX.utils.json_to_sheet(data, {
        skipHeader: true
    });

    /**设置标题头背景色 */
    for (const key in sheet) {
        // 任意一行，表头
        if (parseInt(key.replace(/[^0-9]/ig, '')) <= data.length) {
            sheet[key].s = {
                font: {//字体
                    name: '宋体',
                    sz: 14,
                    bold: key.replace(/[^0-9]/ig, '') === '1' ? true : false,
                    color:{
                        rgb:error.includes(sheet[key].v) ? 'ff1c00' : ''
                    }
                },
                alignment: {
                    horizontal: 'center' //水平居中
                }
            };
        }
        // 设置每一个单元格
        let colsP = titles.map(()=> {
            let obj = {
                'wch': 25 //列宽
            };
            return obj;
        });
        sheet['!cols'] = colsP;//列宽
    }
    openDownload(sheet2blob(sheet, titles.join('-')), dirname);
}
function sheet2blob(sheet, sheetName) {
    let wb = XLSX.utils.book_new();
    wb.SheetNames.push(sheetName);
    wb.Sheets[sheetName] = sheet;
    var wbout = XLSXStyle.write(wb, { bookType: '', bookSST: false, type: 'binary' });
    var blob = new Blob([s2ab(wbout)], { type: '' }, sheetName);

    // 字符串转ArrayBuffer
    function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    }

    return blob;
}
function openDownload(url, saveName) {
    if (typeof url == 'object' && url instanceof Blob) {
        url = URL.createObjectURL(url); // 创建blob地址
    }
    var aLink = document.createElement('a');
    aLink.href = url;
    aLink.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
    var event;
    if (window.MouseEvent) event = new MouseEvent('click');
    else {
        event = document.createEvent('MouseEvents');
        event.initMouseEvent(
            'click',
            true,
            false,
            window,
            0,
            0,
            0,
            0,
            0,
            false,
            false,
            false,
            false,
            0,
            null
        );
    }
    aLink.dispatchEvent(event);
}
export {
    serialize,
    convertMilliseconds,
    exportExcel
}
